function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}
import React, { useCallback } from 'react';
import withRipple from "../../hocs/withRipple";

import {
StyledButton,
StyledSonntagIcon,
RippleContainer,
TruncationWrapper,
IconWrapper } from "./styled";

















export const SonntagButton = ({
  className,
  size,
  outlined = false,
  fullWidth = false,
  iconPath,
  iconSvgCode,
  children,
  disabled = false,
  accentColor,
  iconColor,
  solid = false,
  onClick = () => void 0,
  ...props }) =>
{
  const RippleEffect = withRipple(RippleContainer);

  const renderIcon = useCallback(() => {
    if (!iconPath && !iconSvgCode) {
      return null;
    }
    if (iconPath && !iconSvgCode) {
      return /*#__PURE__*/(
        React.createElement(StyledSonntagIcon, {
          iconPath: iconPath,
          color: iconColor || !solid && accentColor || '',
          onlyIcon: !children }));


    }
    if (iconSvgCode && !iconPath) {
      const SvgIcon = iconSvgCode;
      return /*#__PURE__*/(
        React.createElement(IconWrapper, {
          color: iconColor || !solid && accentColor || '',
          onlyIcon: !children }, /*#__PURE__*/

        React.createElement(SvgIcon, { viewBox: "0 0 1000 1000" })));


    }
    return null;
  }, [iconPath, iconSvgCode, iconColor, solid, accentColor, children]);

  return /*#__PURE__*/(
    React.createElement(StyledButton, _extends({
      className: className,
      size: size,
      outlined: outlined,
      fullWidth: fullWidth,
      disabled: disabled,
      accentColor: accentColor,
      solid: solid,
      withIcon: (iconPath || iconSvgCode) && true,
      onlyIcon: !children,
      onClick: onClick },
    props),

    renderIcon(), /*#__PURE__*/
    React.createElement(TruncationWrapper, null, children),
    !disabled && /*#__PURE__*/React.createElement(RippleEffect, null)));


};